import { z as zod, type ZodType } from 'zod';

import { createBaseDtoSchema } from './create-base-dto-schema';

/**
 * Creates a Zod schema for a base datastream DTO, extending the base DTO schema with an `entryDate` field.
 *
 * @template TId - The Zod type for the `id` field, defaults to `zod.ZodNumber`.
 * @param idSchema - Optional custom Zod schema for the `id` field.
 * @returns A Zod schema that includes all fields from the base DTO schema and an additional `entryDate` string field.
 */
export const createBaseDatastreamDtoSchema = <TId extends ZodType = zod.ZodNumber>(idSchema?: TId) => {
  const baseSchema = createBaseDtoSchema(idSchema);

  return baseSchema.extend({
    entryDate: zod.string().optional(),
  });
};
